import React from "react";
import { kebabCase } from "lodash";
import {SearchApp} from "gatsby-theme-jqi";
import { useNewsCategories } from "gatsby-jqi-graphql-helpers";

const isBrowser = typeof window !== "undefined";

const createDictionary = (arr: JQI.TaxonomyTerm[]): { [key: string]: string } => {
  return arr.reduce((acc, cur: JQI.TaxonomyTerm) => ({
    ...acc,
    [kebabCase(cur.name)]: cur.id,
  }), {});
};

const ArticlesSearch: React.FC<JQI.ArticlesSearchProps> = ({
  args = [],
  hideSearch,
  groupId,
  queryArgs,
}) => {
  const categoryOptions = useNewsCategories() as JQI.TaxonomyTerm[];
  const categoryFilter = {
    label: "News Categories",
    property: "filters.newsCategories",
    options: categoryOptions,
    value: "",
  } as JQI.SearchAppFilterProps;

  if (!!args.length) {
    const categoryFilterIds = categoryOptions.map(({ id }) => `${id}`);
    for (let i = 0; i < args.length; i++) {
      const arg = args[i];
      if (categoryFilterIds.indexOf(arg) !== -1) {
        categoryFilter.value = arg;
      }
    }
  } else {
    const locationHash = isBrowser ? kebabCase(window.location.hash.slice(1)) : "";
    const categoryIdsBySlug = createDictionary(categoryOptions);
    categoryFilter.value = categoryIdsBySlug[locationHash] || "";
  }
  return (
    <SearchApp
      indexName={`articles_index_${groupId}`}
      feedType="article"
      filters={[
        categoryFilter,
      ]}
      queryArgs={queryArgs}
      // query = ""
      hideSearch={hideSearch || !!args.length}
    />
  );
};

export default ArticlesSearch;